/**
 * 개인 공개 랜딩 전용 섹션 레지스트리 (조직 랜딩 SECTION_TEMPLATES와 동일한 형태).
 * templateCode는 저장·운영 템플릿과 정합을 맞추기 위한 식별자다.
 */

export const PERSONAL_SECTION_TEMPLATES = [
  {
    type: 'hero',
    label: '상단 소개',
    maxCount: 1,
    templates: [
      { code: 'personal-hero.centered-v1', label: '밸런스형(기본)' },
      { code: 'personal-hero.split-v1', label: '텍스트 우선·이미지 우측' },
      { code: 'personal-hero.minimal-v1', label: '미니멀 컴팩트' },
    ],
  },
  {
    type: 'about-profile',
    label: '프로필 소개',
    maxCount: 1,
    templates: [
      { code: 'personal-about.media-v1', label: '텍스트 + 이미지형' },
      { code: 'personal-about.card-v1', label: '카드 강조형' },
    ],
  },
  {
    type: 'service-tags',
    label: '서비스 태그',
    maxCount: 1,
    templates: [
      { code: 'personal-services.chips-v1', label: '칩형' },
      { code: 'personal-services.cards-v1', label: '카드 그리드' },
    ],
  },
  {
    type: 'proof-stats',
    label: '성과 지표',
    maxCount: 2,
    templates: [{ code: 'personal-stats.grid-v1', label: '그리드형' }],
  },
  {
    type: 'monthly-issue',
    label: '이달의 이슈',
    maxCount: 1,
    templates: [{ code: 'personal-monthly.split-v1', label: '생보·손보 2열' }],
  },
  {
    type: 'media-gallery',
    label: '미디어 갤러리',
    maxCount: 1,
    templates: [
      { code: 'personal-gallery.grid-v1', label: '그리드형' },
      { code: 'personal-gallery.carousel-v1', label: '캐러셀' },
    ],
  },
  {
    type: 'image-card',
    label: '이미지 카드',
    maxCount: 1,
    templates: [{ code: 'personal-image-card.full-v1', label: '풀폭 이미지' }],
  },
  {
    type: 'career',
    label: '경력',
    maxCount: 1,
    templates: [
      { code: 'personal-text.v1', label: '텍스트' },
      { code: 'personal-timeline.v1', label: '타임라인' },
    ],
  },
  {
    type: 'customer-case',
    label: '상담 사례',
    maxCount: 2,
    templates: [{ code: 'personal-case.cards-v1', label: '카드형' }],
  },
  {
    type: 'activity',
    label: '활동지역',
    maxCount: 1,
    templates: [{ code: 'personal-text.v1', label: '텍스트' }],
  },
  {
    type: 'free-text',
    label: '자유 소개',
    maxCount: 2,
    templates: [{ code: 'personal-text.v1', label: '텍스트' }],
  },
  {
    type: 'contact',
    label: '문의 정보',
    maxCount: 1,
    templates: [
      { code: 'personal-contact.cards-v1', label: '카드형' },
      { code: 'personal-contact.centered-v1', label: '중앙 나열' },
    ],
  },
  {
    type: 'cta',
    label: '상담 유도',
    maxCount: 1,
    templates: [
      { code: 'personal-cta.split-v1', label: '버튼 분할형' },
      { code: 'personal-cta.stack-v1', label: '세로 스택' },
    ],
  },
  {
    type: 'credentials',
    label: '자격·이력',
    maxCount: 1,
    templates: [{ code: 'personal-credentials.list-v1', label: '리스트형' }],
  },
  {
    type: 'values',
    label: '고객 약속',
    maxCount: 1,
    templates: [{ code: 'personal-values.cards-v1', label: '3카드형' }],
  },
  {
    type: 'faq',
    label: '자주 묻는 질문',
    maxCount: 1,
    templates: [{ code: 'personal-faq.accordion-v1', label: '아코디언' }],
  },
  {
    type: 'ad-review',
    label: '광고 심의필·준법',
    maxCount: 1,
    templates: [{ code: 'personal-ad-review.disclaimer-v1', label: '하단 고지형' }],
  },
]

/** 조직 랜딩 전용 타입 — 개인 랜딩에서 금지 */
export const PERSONAL_FORBIDDEN_ORG_SECTION_TYPES = new Set([
  'ga-intro',
  'ceo-message',
  'business-intro',
  'benefits',
  'lead-form',
])

const DEFAULT_TEMPLATE_BY_TYPE = Object.fromEntries(
  PERSONAL_SECTION_TEMPLATES.map((row) => [row.type, row.templates[0]?.code || ''])
)

export function getPersonalSectionMeta(type) {
  return PERSONAL_SECTION_TEMPLATES.find((item) => item.type === type) || null
}

export function getPersonalTemplateMeta(templateCode) {
  if (!templateCode) return null
  for (const section of PERSONAL_SECTION_TEMPLATES) {
    const match = section.templates.find((item) => item.code === templateCode)
    if (match) return { ...match, type: section.type, sectionLabel: section.label }
  }
  return null
}

export function getDefaultPersonalTemplateCode(type) {
  return DEFAULT_TEMPLATE_BY_TYPE[type] || ''
}

/** 저장된 templateCode가 해당 type에 없으면 기본값으로 교정 */
export function resolvePersonalTemplateCode(type, templateCode) {
  const meta = getPersonalTemplateMeta(templateCode)
  if (meta && meta.type === type) return templateCode
  return getDefaultPersonalTemplateCode(type) || templateCode
}

export function getPersonalSectionMaxCount(type) {
  const row = PERSONAL_SECTION_TEMPLATES.find((item) => item.type === type)
  return row?.maxCount ?? 1
}
